// extracted by mini-css-extract-plugin
module.exports = {"addReasonWindow":"addReasonWindow__N6R37","reasonInput":"reasonInput__4ihQr"};